import containersStyle from '../../common/css/containers.module.css';
import { ClientList } from "../../features/oauth2/components/ClientList";

export const ClientListPage = () => {
    return (
        <div className={containersStyle.formContainerLarge}>
            <ClientList />
        </div>
    );
}